// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__15eeB","content":"Page_content__3WPuF","scrollingDisabled":"Page_scrollingDisabled__3-CeQ"};